/*
    Use the following classes in the html:
        -js-accordion
        -js-accordion__trigger
        -js-accordion__target
*/
const baseClass = '-js-accordion';
const openClass = `${baseClass}--open`;
const initHeight = '100vh';

// Collect necessary elements of each accordion on page

let accordionInfos = [];
[...document.querySelectorAll(`.${baseClass}`)].forEach((accordion) => {
    const classList = accordion.classList;
    const trigger = accordion.querySelector(`.${baseClass}__trigger`);
    const ignoredElementsInTrigger = accordion.querySelectorAll(`.${baseClass}__trigger .${baseClass}__ignore`);
    const target = accordion.querySelector(`.${baseClass}__target`);
    accordionInfos.push({
        classList,
        trigger,
        target,
        ignoredElementsInTrigger,
    });
});

// Do for each accordion on page

accordionInfos.forEach(({ classList, trigger, target, ignoredElementsInTrigger }) => {
    if (!trigger || !target) {
        return;
    }

    target.dataset.maxHeight = initHeight;
    trigger.addEventListener('click', () => {
        const open = classList.contains(openClass);
        classList.toggle(openClass);
        if (open) {
            target.style.maxHeight = 0;
        } else {
            target.style.maxHeight = target.dataset.maxHeight;
        }
        setTimeout(() => {
            if (classList.contains(openClass) && target.dataset.maxHeight == initHeight) {
                setMaxHeight(target);
            }
        }, 300);

        // close others
        // if (classList.contains('faq-question')) {
        //     const others = trigger.closest('.faq__questions').querySelectorAll(`.${baseClass}`);
        //     [...others].forEach((otherAccordion) => {
        //         if (otherAccordion == trigger.closest(`.${baseClass}`)) return;
        //         const otherTarget = otherAccordion.querySelector(`.${baseClass}__target`);
        //         otherAccordion.classList.remove(openClass);
        //         otherTarget.style.maxHeight = 0;
        //         setTimeout(() => {
        //             if (otherAccordion.classList.contains(openClass) && otherTarget.dataset.maxHeight == initHeight) {
        //                 setMaxHeight(otherTarget);
        //             }
        //         }, 300);
        //     });
        // }
    });
    if (ignoredElementsInTrigger) {
        [...ignoredElementsInTrigger].forEach((ignoredElement) => {
            ignoredElement.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        });
    }
});

function setMaxHeight(element) {
    if (!element) return;

    element.style.maxHeight = 'none';
    const height = element.offsetHeight;
    element.style.maxHeight = height + 20 + 'px';
    element.dataset.maxHeight = height + 20 + 'px';
}

let timeout;
window.addEventListener('resize', () => {
    if (timeout) {
        window.cancelAnimationFrame(timeout);
    }

    timeout = window.requestAnimationFrame(function () {
        accordionInfos.forEach(({ classList, target }) => {
            if (!target) return;
            if (classList.contains(openClass)) {
                setMaxHeight(target);
            } else {
                target.dataset.maxHeight = initHeight;
            }
        });
    });
});
